<template>
  <div class="user-box ml-2">
    <a
      href="javascript:void(0);"
      class="p-0 d-flex align-items-center"
      id="userBoxPopover"
    >
      <div class="d-block p-0 avatar-icon-wrapper">
        <span class="badge badge-circle badge-success p-top-a">Online</span>
        <div class="avatar-icon rounded">
          <template v-if="dataProfile.foto_profile === null">
            <img src="@/assets/img/avatars/avatar3.jpg" alt="" />
          </template>
          <template v-else>
            <img :src="dataProfile.foto_profile" class="img-pp" />
          </template>
        </div>
      </div>
      <div class="d-none d-md-block pl-2">
        <div
          id="element-nama"
          ref="ref-element-nama"
          class="font-weight-bold wrap-text"
          @mouseover="checkTextOverflow('ref-element-nama', 'ref_popover_nama')"
          @mouseleave="handleMouseLeave('ref_popover_nama')"
        >
          <b-popover
            container="element-nama"
            target="element-nama"
            ref="ref_popover_nama"
            placement="bottom"
          >
            {{ klinikRoleName.name }}
          </b-popover>
          {{ klinikRoleName.name }}
        </div>
        <span class="text-black-50" v-if="faskes == 2">
          <template v-if="userRole == 'Operator'">
            Asisten Dokter
          </template>
          <template v-else>
            {{
              userRole == "dokter praktek" ? "Dokter Praktik" : "Dokter Praktik"
            }}
          </template>
        </span>
        <span class="text-black" v-else>
          {{ klinikRoleName.role }}
        </span>
      </div>
      <span class="pl-3">
        <font-awesome-icon icon="angle-down" class="opacity-5" />
      </span>
    </a>
    <b-popover
      triggers="click blur"
      placement="bottom"
      ref="userBoxPopover"
      target="userBoxPopover"
    >
      <ul class="list-group list-group-flush text-left bg-transparent">
        <li class="list-group-item rounded-top">
          <ul class="nav nav-pills nav-pills-hover flex-column">
            <li class="d-block d-md-none font-weight-bold">
              {{ klinikRoleName.name }}
            </li>
            <li class="d-block d-md-none nav-item text-black-50">
              <template v-if="userRole == 'Operator'">
                Asisten Dokter
              </template>
              <template v-else>
                {{ userRole }}
              </template>
            </li>
            <li class="d-block d-md-none nav-item"><hr /></li>
            <template v-if="!initPage">
              <template v-if="/dokter_klinik|pic/.test(this.getRolesName)">
                <li class="nav-item text-capitalize">
                  <a
                    class="nav-link"
                    href="javascript:void(0);"
                    @click="pageAccountProfile()"
                  >
                    Pengaturan Akun
                  </a>
                </li>
              </template>
              <template
                v-else-if="
                  userRole !== 'Operator' &&
                    this.$store.state.initPosition != 'klinik'
                "
              >
                <li class="nav-item text-capitalize">
                  <a
                    class="nav-link"
                    href="javascript:void(0);"
                    @click="pageProfile"
                  >
                    Pengaturan Akun
                  </a>
                </li>
              </template>
              <li class="nav-item text-capitalize">
                <a
                  class="nav-link"
                  href="javascript:void(0);"
                  @click="showModal"
                >
                  ubah password
                </a>
              </li>
            </template>
            <li class="nav-item text-capitalize">
              <a class="nav-link" href="javascript:void(0);" @click="logout">
                log out
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </b-popover>
    <b-modal ref="ubah-password" hide-footer title="Ubah Password">
      <b-form row v-on:submit.prevent="submitForm">
        <div class="col-sm-12">
          <b-form-group
            v-for="form in formBasicData"
            :key="form.tmpId"
            :invalid-feedback="
              renderInvalidFeedback({
                validationDesc: form['validation-desc']
              })
            "
            :state="renderError({ error: form.error })"
          >
            <label for="">{{ form.labelName }}</label>
            <b-input-group>
              <b-input-group-text
                slot="append"
                class="border-left-0"
                v-if="form.labelName == 'Password Lama'"
                @click="switchVisibilityPassword"
              >
                <font-awesome-icon v-if="passwordVisible == false" icon="eye" />
                <font-awesome-icon v-else icon="eye-slash" />
              </b-input-group-text>

              <b-input-group-text
                slot="append"
                class="border-left-0"
                v-if="form.labelName == 'Password Baru'"
                @click="switchVisibilityPasswordConfirmation"
              >
                <font-awesome-icon
                  v-if="passwordVisible1 == false"
                  icon="eye"
                />
                <font-awesome-icon v-else icon="eye-slash" />
              </b-input-group-text>

              <b-input-group-text
                slot="append"
                class="border-left-0"
                v-if="form.labelName == 'Konfirmasi Password Baru'"
                @click="switchVisibilityPasswordConfirmation1"
              >
                <font-awesome-icon
                  v-if="passwordVisible2 == false"
                  icon="eye"
                />
                <font-awesome-icon v-else icon="eye-slash" />
              </b-input-group-text>

              <b-form-input
                @input="
                  setValuePassword({
                    rawLabel: form.rawLabel,
                    label: form.label,
                    $event,
                    tmpId: form.tmpId
                  })
                "
                :state="renderError({ error: form.error })"
                :placeholder="form.placeholder"
                :maxlength="form.maxlength"
                :type="form.type"
              />
            </b-input-group>
          </b-form-group>
          <b-button
            class="ml-3 text-uppercase"
            variant="success"
            style="font-size:17.5px;float:right "
            type="submit"
          >
            simpan
          </b-button>
          <b-button
            class="ml-3 text-uppercase"
            variant="danger"
            style="font-size:17.5px;float:right "
            @click="hideModal"
          >
            Batal
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { EventBus } from "../../../event-bus";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlusCircle,
  faChartBar,
  faAngleDown,
  faEye,
  faEyeSlash
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faDribbble } from "@fortawesome/free-brands-svg-icons";
import startCase from "lodash/startCase";
library.add(
  faDribbble,
  faPlusCircle,
  faChartBar,
  faEye,
  faEyeSlash,
  faAngleDown
);
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data: () => ({
    dataProfile: [],
    formData: null,
    formBasicData: null,
    passwordVisible: false,
    passwordVisible1: false,
    passwordVisible2: false,
    klinikRoleName: {
      role: null,
      name: null
    },
    dataRole: [
      {
        key: "owner_klinik",
        value: "Pemilik Faskes",
        index: 0 // jabatan tertinggi
      },
      {
        key: "pic_cabang",
        value: "PIC Faskes",
        index: 2
      },
      {
        key: "dokter_klinik",
        value: "Dokter",
        index: 3
      },
      {
        key: "manajemen",
        value: "Manajemen",
        index: 1
      }
    ]
  }),
  components: {
    "font-awesome-icon": FontAwesomeIcon
  },
  validations() {
    return {
      formData: {
        password_lama: {
          required,
          maxLength: maxLength(15)
        },
        password_baru: {
          required,
          maxLength: maxLength(15),
          verifyPassword(val) {
            if (val.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/)) {
              return true;
            } else {
              return false;
            }
          }
        },
        konfirmasi_password_baru: {
          required,
          sameAsPassword: sameAs("password_baru"),
          minLength: minLength(6),
          maxLength: maxLength(15)
        }
      }
    };
  },
  mounted() {
    if (/pic/.test(this.getRolesName)) {
      this.getProfile().then(res => {
        if (res) {
          this.getProfileKlinik();
        }
      });
    } else {
      this.getProfile();
    }
    this.formBasicData = this.setformBasicData();
    this.formData = this.setformData();
    this.watchImageUploaded();
  },
  computed: {
    ...mapGetters({
      initPage: "sidebar/initPage",
      getRolesName: "getRolesName",
      faskes: "faskes",
      getKlinikId: "getKlinikId",
      getFaskesType: "getFaskesType"
    }),
    userName() {
      return startCase(this.$store.state.user.nama);
    },
    userRole() {
      let user = this.$store.state.user;
      let role = null;
      if (user) {
        if (user.roles && user.roles.length > 0) {
          role = user.roles[0].name;
          return startCase(role);
        }
      }
      return role;
    },
    klinik() {
      let kklinik = this.$store.state.klinikUser.filter(item => {
        return item.pivot.klinik_id === this.$store.state.klinikId;
      });

      return kklinik[0];
    }
  },
  methods: {
    handleMouseLeave(poper_ref) {
      this.$refs[poper_ref].$emit("close");
    },
    checkTextOverflow(select_ref, poper_ref) {
      const inputElement = this.$refs[select_ref];

      if (inputElement.scrollWidth > inputElement.clientWidth) {
        this.$refs[poper_ref].$emit("open");
      }
    },
    ...mapActions("SuratPenunjangStore", ["ResetSuratPenunjangStore"]),
    ...mapMutations({
      setStatusQrisPayment: "SET_STATUS_QRIS_PAYMENT"
    }),
    pageAccountProfile() {
      if (
        this.getRolesName.includes("pic_cabang") ||
        this.getRolesName.includes("pic_pusat")
      ) {
        this.$router.push("/account-setting/klinik");
      } else {
        this.$router.push("/account-setting/klinik");
      }
    },
    watchImageUploaded() {
      EventBus.$on("image-uploaded", async val => {
        if (/pic/.test(this.getRolesName)) {
          await this.getProfileKlinik(val);
          await this.getProfile();
        } else {
          await this.getProfile();
        }
      });
    },
    async getProfile() {
      try {
        var profile = this.$store.state.user.id;
        const res = await this.$axios.get(
          `user/${profile}?klinik_id=${this.getKlinikId}`
        );
        this.dataProfile = res.data.data;
        this.getKlinikRoleName();
        return true;
      } catch (e) {}
    },
    async getProfileDokter() {
      let profile = this.$store.state.user.id;
      const res = await this.$axios.get(
        `klinik/dokter/${profile}?klinik_id=${this.getKlinikId}&profile=true`
      );

      const { data } = res.data;
      this.dataProfile.foto_profile = data.foto_dokter;
    },
    async getProfileKlinik(type = '') {
      try {
        let profile;

        this.$store.state.klinikUser.map(data => {
          if (data.parent_id != null && data.id == this.getKlinikId) {
            profile = data.parent_id;
          }
        });

        const res = await this.$axios.get(
          `klinik/${this.getKlinikId}?klinik_id=${profile}&profile=true`
        );

        const { data } = res.data;
        this.setStatusQrisPayment(data.qrisConfig);
        if(type != 'pic-profile') {
          this.getKlinikRoleName();
        }
      } catch (error) {}
    },
    getKlinikRoleName() {
      this.klinikRoleName = {
        role: this.parseArrayRoles(this.getRolesName),
        name: this.dataProfile.nama
      };
    },
    parseArrayRoles(arrayRolesData) {
      var strRoles = "Staff";
      var count = 1;

      var fRoles = this.filterRoles();
    
      if (fRoles.length > 0) {
        // for dpm
        if(fRoles.length == 2 && this.getFaskesType) {
          return fRoles[1].value + ' Praktik'
        }
        return (strRoles = fRoles[0].value);
      }

      if (arrayRolesData.length < 3) {
        strRoles = "";
        arrayRolesData.forEach(element => {
          strRoles += startCase(element);
          if (count != arrayRolesData.length) {
            strRoles += "/";
          }
          count++;
        });
      }

      return strRoles;
    },
    filterRoles() {
      var tempData = this.dataRole.filter(item => {
        return this.getRolesName.includes(item.key);
      });

      tempData = tempData.sort((a, b) => {
        if (a.index < b.index) {
          return -1;
        }
        if (a.index > b.index) {
          return 1;
        }
        return 0;
      });
      return tempData;
    },
    submitForm() {
      const tmp = this.formBasicData.filter(item => item.label);
      if (tmp.every(item => item.error !== null && !item.error)) {
        this.changePassword();
      } else {
        tmp.map(item => {
          this.triggerValidation({
            label: item.label,
            $v: this.$v,
            $vm: this
          });
        });
      }
    },
    switchVisibilityPassword() {
      this.formBasicData[0].type == "password"
        ? (this.formBasicData[0].type = "text")
        : (this.formBasicData[0].type = "password");
      if (this.formBasicData[0].type == "text") {
        this.passwordVisible = true;
      } else if (this.formBasicData[0].type == "password") {
        this.passwordVisible = false;
      }
    },
    switchVisibilityPasswordConfirmation() {
      this.formBasicData[1].type == "password"
        ? (this.formBasicData[1].type = "text")
        : (this.formBasicData[1].type = "password");
      if (this.formBasicData[1].type == "text") {
        this.passwordVisible1 = true;
      } else if (this.formBasicData[1].type == "password") {
        this.passwordVisible1 = false;
      }
    },
    switchVisibilityPasswordConfirmation1() {
      this.formBasicData[2].type == "password"
        ? (this.formBasicData[2].type = "text")
        : (this.formBasicData[2].type = "password");
      if (this.formBasicData[2].type == "text") {
        this.passwordVisible2 = true;
      } else if (this.formBasicData[2].type == "password") {
        this.passwordVisible2 = false;
      }
    },
    setformData() {
      return this.setformBasicData().reduce((arr, val) => {
        arr[val.label.split(" ").join("_")] = null;
        return arr;
      }, {});
    },
    setformBasicData() {
      const tmp = [
        {
          label: "password lama",
          placeholder: "Masukkan password Anda",
          type: "password",
          name: "old_password",
          isType: "password",
          labelName: "Password Lama",
          maxlength: 15
        },
        {
          label: "password baru",
          placeholder: "Masukkan password Anda",
          type: "password",
          isType: "password",
          name: "new_password",
          labelName: "Password Baru",
          maxlength: 15
        },
        {
          label: "konfirmasi password baru",
          placeholder: "Masukkan password Anda sekali lagi",
          type: "password",
          isType: "password",
          name: "confirm_new_password",
          labelName: "Konfirmasi Password Baru",
          maxlength: 15
        }
      ].map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        rawLabel: item.label
      }));
      return tmp;
    },
    setValuePassword({ label, rawLabel, $event = null } = {}) {
      const value = $event;
      this.formData[label] = value && value.trim();
      const confirms = ["password_baru", "konfirmasi_password_baru"];
      if (confirms.includes(label)) {
        confirms.forEach(item => {
          this.triggerValidation({
            label: item,
            $v: this.$v,
            $vm: this,
            rawLabel: item.split("_").join(" ")
          });
        });
      } else {
        this.triggerValidation({
          label,
          $v: this.$v,
          $vm: this,
          rawLabel
        });
      }
    },
    showModal() {
      this.$refs["ubah-password"].show();
    },
    hideModal() {
      this.$refs["ubah-password"].hide();
    },
    pageProfile() {
      var checkRole = this.$store.state.user.roles[0];
      if (checkRole) {
        this.$router.push("/account-setting/klinik");
      }
    },
    async goIdle() {
      var currentUrl = window.location.pathname;

      this.$store.commit("SET_BEARER_TOKEN", null);
      this.$store.commit("SET_AUTHERROR", null);
      localStorage.setItem("IDLE", 1);
      localStorage.setItem("LAST_URL", currentUrl);

      let profile = this.$store.state.user.id;
      const res = await this.$axios.get(
        `user/${profile}?klinik_id=${this.getKlinikId}`
      );
      localStorage.setItem("TIPE_FASKES", res.data.data.klinik.tipe_faskes);

      this.$router.push("/idle");
    },
    showTooltip() {
      this.$refs.tooltipSuccess._toolpop
        .getTipElement()
        .classList.add("tooltip-success");
    },
    showPopoverIntegrations() {
      this.$refs.userBoxPopover._toolpop
        .getTipElement()
        .classList.add(
          "popover-custom-wrapper",
          "popover-custom-lg",
          "popover-secondary"
        );
    },
    async changePassword() {
      try {
        const { formData, formBasicData } = this;

        const tmpPostData = formBasicData.reduce((obj, item) => {
          const { label, name } = item;
          obj[name] = formData[label];
          return obj;
        }, {});

        const postData = {
          ...tmpPostData
        };
        const res = await this.$axios.post(
          `change_password`,
          postData
        );
        const { status, data, message } = res.data;
        if (status) {
          this.$swal({
            title: "Berhasil",
            text: `Password Berhasil di Perbaharui`,
            type: "success",
            confirmButtonText: startCase("ya")
          });
          this.hideModal();
          this.$router.push("/");
        } else {
          this.$swal({
            title: "Gagal",
            text: `Password Gagal diperbaharui`,
            type: "error",
            confirmButtonText: startCase("ya")
          });
          this.hideModal();
          this.$router.push("/");
        }
      } catch {
        this.$swal({
          title: "Gagal",
          text: `Password Lama Anda Salah`,
          type: "error",
          confirmButtonText: startCase("ya")
        });
      }
    },
    async logout() {
      this.ResetSuratPenunjangStore();
      localStorage.removeItem("show_campaign");
      try {
        const res = await this.$axios.post(`logout`);
        const { status, data, message } = res.data;
        if (status) {
          this.$store.commit("SET_BEARER_TOKEN", null);
          this.$store.commit("SET_USER", null);
          this.$store.commit("SET_AUTHERROR", null);
          localStorage.removeItem("REMINDER");
          this.$router.go("/login");
        }
      } catch (err) {
        // console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.img-pp {
  width: 100% !important;
  height: auto !important;
}

.wrap-text {
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
